// https://developer.7moor.com/dc/#/online/webCustomerService
// 原生网页脚本接入：在加载 7moorInit.js 前赋值 window.qimoClientId。
const text = (value) => String(value ?? "").trim();

export function buildCustomerServiceClient(user) {
  const userId = text(user?.userId);
  if (!userId) return null;
  return {
    userId,
    nickName: text(user.nickName) || text(user.userName) || userId,
    customField: Object.fromEntries([
      ["用户ID", userId],
      ["账号", text(user.userName)],
      ["昵称", text(user.nickName)],
      ["客户编码", text(user.cusCode)],
      ["客户名称", text(user.cusName)],
      ["联系电话", text(user.phone)],
      ["邮箱", text(user.email)],
    ].filter(([, value]) => value)),
  };
}
